export default "__VITE_ASSET__DdAUezk5__"